import { useState } from 'react';

import RouterPreloader from '@components/RouterPreloader';
import { DeliveryFlowForSellerModal } from '@components/settings/DeliveryFlowForSellerModal';
import { getFieldsSingleError } from '@utils/common';
import { PaymentMethodErrorModal } from '@components/settings/PaymentMethodErrorModal';
import { logger } from '@utils/logger';

import {
  useUpdateSettingsOnSellerFlowMutation,
  useDeliveryFlowForSellersQuery,
} from './graphql.v4.generated';

type DeliveryFlowForSellersContainerProps = {
  isOpen: boolean
  onClose?: () => void
};

export const DeliveryFlowForSellersContainer:
React.FC<DeliveryFlowForSellersContainerProps> = ({
  isOpen,
  onClose,
}) => {
  const [errorText, setErrorText] = useState<string>();
  const { data, loading, error } = useDeliveryFlowForSellersQuery({
    context: {
      v4: true,
      batch: true,
    },
    skip: !isOpen,
    fetchPolicy: 'network-only',
  });

  const [updateSettings] = useUpdateSettingsOnSellerFlowMutation({
    context: { v4: true },
  });

  if (loading) {
    return <RouterPreloader />;
  }

  if (error || !data) {
    return null;
  }

  if (!data?.viewer || !data?.viewer) {
    logger.error('Empty render');
    return null;
  }

  const { deliverySettings, paymentMethods } = data.viewer;

  const onSubmit = async () => {
    // if user dont change any settings we need set time of updating settings
    // for that we update settings with same data
    if (paymentMethods) {
      const response = await updateSettings({
        variables: {
          deliveryService: deliverySettings[0].deliveryService,
          isEnabledDeliveryService: deliverySettings[0].isEnabled,
          paymentMethod: paymentMethods[0].id,
          isEnabledPaymentMethod: paymentMethods[0].isEnabled,
        },
      });
      const rawErrors = response?.data?.updatePaymentMethods?.errors;
      if (rawErrors?.length) {
        const fieldErrors = getFieldsSingleError(rawErrors);
        setErrorText(Object.values(fieldErrors)[0]);
      }
    }

    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      <DeliveryFlowForSellerModal
        onSubmit={onSubmit}
        isOpen={isOpen}
        onRequestClose={onClose}
      />

      <PaymentMethodErrorModal
        isOpen={!!errorText}
        text={errorText || ''}
        onRequestClose={() => setErrorText(undefined)}
      />
    </>
  );
};
